/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

export const isAppleCNA = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  
  return ((userAgent.includes('iphone') !== -1 || userAgent.indexOf('ipad') !== -1) &&
  (userAgent.indexOf('mozilla/') !== -1) &&
  (userAgent.indexOf('applewebkit/') !== -1) &&
  (userAgent.indexOf('mobile/') !== -1) &&
  (userAgent.indexOf('safari/') === -1));
};

export const isIOS = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export const isAndroid = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return /android/.test(userAgent);
};

export const isMobile = () => {
  return isIOS() || isAndroid();
};

export const isIPad = () => {
  return /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document;
}
